import React from 'react';
import {
  Container,
  Typography,
  Button,
  Paper,
  Box,
  Link,
  Grid,
  ThemeProvider,
  createTheme,
} from '@mui/material';
import { styled } from '@mui/system';
import { ArrowRight, PiggyBank, Tv, Smartphone, UserCheck } from 'lucide-react';
import './ExistingCustomer.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ff385c',
    },
    secondary: {
      main: '#00a699',
    },
    background: {
      default: '#f8f8f8',
    },
  },
  typography: {
    fontFamily: "'Arial', sans-serif",
  },
});

const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(8),
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: '24px',
  padding: theme.spacing(1.5, 4),
  fontWeight: 600,
  textTransform: 'none',
  fontSize: '1rem',
}));

const StyledNote = styled(Typography)(({ theme }) => ({
  fontStyle: 'italic',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2),
}));

const IncentiveItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(2),
}));

const IncentiveIcon = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginRight: theme.spacing(2),
  marginTop: '4px',
}));

const ExistingCustomer = () => {
  const incentives = [
    { icon: PiggyBank, text: 'Savings' },
    { icon: Tv, text: 'Perks from the carriers such as Disney+, Hulu, Netflix, HBO Max, etc.' },
    { icon: Smartphone, text: 'Ability to finance your device and add-ons' },
    { icon: UserCheck, text: 'Dedicated Circledin Success Manager' },
  ];

  return (
    <ThemeProvider theme={theme}>
      <div className="existing-customer">
        <StyledContainer maxWidth="md">
          <StyledPaper>
            <Typography variant="h4" component="h1" gutterBottom align="center">
              Existing Customers
            </Typography>
            <Typography variant="h6" gutterBottom align="center">
              Interested in becoming an Account Owner? Add your plan <Link href="#" color="primary">here</Link>!
            </Typography>
            
            <StyledNote variant="body2">
              Note: If you come from a prepaid service from one of the carriers, please choose "Switching Carriers."
            </StyledNote>
            
            <Typography variant="body1" paragraph>
              Partner up with Circledin as an Account Owner and take charge of your Circle.
            </Typography>
            
            <Typography variant="body1" paragraph>
              Incentives to becoming an Account Owner include:
            </Typography>
            
            <Grid container spacing={3}>
              {incentives.map((incentive, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <IncentiveItem className="incentive-item">
                    <IncentiveIcon className="incentive-icon">
                      <incentive.icon size={24} />
                    </IncentiveIcon>
                    <Typography variant="body1">{incentive.text}</Typography>
                  </IncentiveItem>
                </Grid>
              ))}
            </Grid>
            
            <StyledNote variant="body2" sx={{ mt: 2 }}>
              Note: If you are coming from a prepaid Verizon, T-Mobile, or AT&T account, please choose "Switching Carriers"
            </StyledNote>
            
            <Box mt={4} display="flex" justifyContent="center">
              <StyledButton
                variant="contained"
                color="primary"
                endIcon={<ArrowRight />}
                className="fade-in"
              >
                Post your Circle!
              </StyledButton>
            </Box>
          </StyledPaper>
        </StyledContainer>
      </div>
    </ThemeProvider>
  );
};

export default ExistingCustomer;